import React from 'react';
import { useTranslation } from 'react-i18next';

import FeatherIcon from '../../../components/common/FeatherIcon';

const K = ({ children }) => <kbd className="sa3-kbd">{children}</kbd>;

/** The keyboard shortcuts sheet, shared by the page and the panel. */
export default function ShortcutsDialog({ onClose, inPanel = false }) {
  const { t } = useTranslation('aiExplorer');
  return (
    <div className="sa3-scrim" role="presentation" onClick={onClose}>
      <div className="sa3-dialog" role="dialog" aria-modal="true" aria-label={t('agent.shortcuts')} onClick={(e) => e.stopPropagation()}>
        <header>
          <span>{t('agent.shortcuts')}</span>
          <button type="button" className="sa3-ibtn sm" onClick={onClose} aria-label={t('agent.close')}><FeatherIcon name="x" size={16} /></button>
        </header>
        <dl>
          <dt><K>Enter</K></dt><dd>{t('agent.scSend')}</dd>
          <dt><K>Shift</K> <K>Enter</K></dt><dd>{t('agent.scNewline')}</dd>
          <dt><K>/</K></dt><dd>{t('agent.scCommands')}</dd>
          <dt><K>↑</K></dt><dd>{t('agent.scEditLast')}</dd>
          <dt><K>Esc</K></dt><dd>{inPanel ? t('agent.scStopOrClose') : t('agent.scStop')}</dd>
          <dt><K>⌘</K> <K>K</K></dt><dd>{t('agent.scSearch')}</dd>
          <dt><K>⌘</K> <K>⇧</K> <K>O</K></dt><dd>{t('agent.scNewChat')}</dd>
          {inPanel && <><dt><K>⌘</K> <K>J</K></dt><dd>{t('agent.scTogglePanel')}</dd></>}
        </dl>
      </div>
    </div>
  );
}
